/**
 * Composable for managing product data
 * Handles fetching and storing product information
 */
import { ref } from 'vue';
import { API } from '@/constants/urls';

/**
 * Create a products management composable
 * 
 * @param {string} apiUrl - The API URL
 * @returns {Object} - Products management methods and state
 */
export function useProducts(apiUrl = API.BASE) {
  // Main product data
  const mainProduct = ref(null);
  // Products collection indexed by product ID
  const products = ref({});
  // Slug from URL
  const slug = ref('');
  
  /**
   * Extract slug from URL path
   * 
   * @returns {string} - The extracted slug
   */
  const initSlug = () => {
    const path = window.location.pathname;
    const segments = path.split('/');
    slug.value = segments.pop() || segments.pop();
    console.log('URL segments:', segments, 'slug:', slug.value);
    return slug.value;
  };
  
  /**
   * Fetch product data from the API
   * 
   * @returns {Promise<Object|null>} - Object containing mainProduct and products or null on error
   */
  const fetchProductData = async () => {
    try {
      const response = await fetch(`${apiUrl}/store/plugin?product=${slug.value}`);
      const data = await response.json();
      console.log('Fetched product data:', data);
      
      // Set main product
      mainProduct.value = data.data.selected_product;
      
      // Map products to object with IDs as keys
      data.data.products.forEach(product => {
        products.value[product._id] = product;
      });
      
      // Make sure main product is also in the products object
      products.value[mainProduct.value._id] = mainProduct.value;
      
      // Notify parent frame content is ready
      window.parent.postMessage('content-slid-out', '*');
      
      return { mainProduct: mainProduct.value, products: products.value };
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  };
  
  return {
    slug,
    mainProduct,
    products,
    initSlug,
    fetchProductData
  };
}